import { Pipe, PipeTransform } from '@angular/core';

import { isProductActive } from 'src/app/constants/constants';

@Pipe({ name: 'verificationPermission' })
export class VerificationPermissionPipe implements PipeTransform {
  transform(
    isMaster: boolean,
    customerAlias: any,
    customerDocument: any,
    hasUserWebAccess: boolean,
    userMetaData: any,
    hasUserAdminPermissions: boolean
  ) {
    if (!hasUserWebAccess) {
      return false;
    }
    const isUserZentraleLeitstelleBsr =
      this.checkIfUserIsZentraleLeitstelleBsr(customerDocument);

    return (
      (customerDocument['customerId'] == '10106' ||
        customerDocument['customerId'] == '10336') &&
      isProductActive(
        isMaster,
        customerAlias,
        customerDocument,
        hasUserWebAccess,
        userMetaData,
        'egpProducts'
      ) &&
      (customerDocument['isMaster'] ||
        hasUserAdminPermissions ||
        isUserZentraleLeitstelleBsr)
    );
  }

  checkIfUserIsZentraleLeitstelleBsr(customerDocument): boolean {
    if (customerDocument['customerId'] != '10106') {
      return false;
    }
    return (
      customerDocument.hasOwnProperty('userId') &&
      customerDocument['userId'] == '5185'
    );
  }
}
